import { Event, MissedEvent } from '../interfaces';

export const isSentToProcessor = (event: Event | MissedEvent): boolean => {
  return event.evidence_status !== null;
};
